import { operationsJournalMock } from "./operationsJournalMock";

/** Мок сохранённых корректировок: переопределённые поля по префиксу документа */
const CORRECTIONS_BY_PREFIX = {
  "KO": {
    fields: { projectDt: "ЖК Riverside", articleOpiuDt: "Себестоимость" },
    author: "Иванов И.",
    date: "27.08.2026",
  },
  "ПО": {
    fields: {
      articleOpiuDt: "Ком. расходы",
      cashAccountKt: "р/с Халык",
      amount: 2100000,
    },
    author: "Иванов И.",
    date: "27.08.2026",
  },
};

/** { [rowId]: { fields, author, date } } */
export const buildInitialCorrections = () =>
  operationsJournalMock.reduce((acc, row) => {
    const [prefix] = row.document.split("-");
    const correction = CORRECTIONS_BY_PREFIX[prefix];
    if (correction) {
      acc[row.id] = { ...correction, fields: { ...correction.fields } };
    }
    return acc;
  }, {});
